import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EPriceAndQualityScoreActionTypes {
  SetRating = 'NEW_REVIEW/PRICE_AND_QUALITY/SET',
}

type TSetPriceAndQualityScore = ITypedReduxAction<EPriceAndQualityScoreActionTypes.SetRating, number>;

export const setPriceAndQualityScore: (rating: number) => TSetPriceAndQualityScore = actionGenerator<
  EPriceAndQualityScoreActionTypes.SetRating,
  number
>(EPriceAndQualityScoreActionTypes.SetRating);

export type TPriceAndQualityScore = TSetPriceAndQualityScore;
